// src/utilis/apiService.js
import { useState, useEffect } from "react";
import axios from "axios";

const baseUrl = process.env.REACT_APP_API_URL_REACT;
const basePage = process.env.REACT_APP_API_URL_REACT  + 'get-data-page/';
export const CONTENT_BASE = process.env.REACT_APP_CONTENT_URL || "https://gestione.carellidistribuzione.it/contenuti";


export default function useFetchPageData(pageIdentifier) {
  const [sectionsData, setSectionsData] = useState([]);
  const [loading, setLoading]       = useState(true);
  const [error, setError]           = useState(null);
  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const res = await axios.get(
          `${basePage}${pageIdentifier}?t=${Date.now()}`
        );
  
        const dataObject = res.data.data[pageIdentifier] || {};
        const arr = Object.values(dataObject);

        //ordine in base all'ordine
        const sectionsArray = arr.sort(
          (a, b) => Number(a.ordine) - Number(b.ordine)
        );
  
        console.log(sectionsArray);
        setSectionsData(sectionsArray);
      } catch (err) {
        console.error("Errore durante il caricamento dei dati:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  }, [pageIdentifier]);
  
  return { sectionsData, loading, error };
}


export async function fetchNewsEvents(offset = 0, limit = 10) {
  const url = `${baseUrl}detail/news-ed-eventi?offset=${offset}&limit=${limit}`;
  const res = await axios.get(url);
  return res.data.data || [];
}


export async function fetchBlog(slug) {
  const url = `${baseUrl}detail/news-ed-eventi/${encodeURIComponent(slug)}`;
  const res = await axios.get(url);
  return res.data.data || [];
}

//Mi pprendo i punti vendita che hanno avuto l'estrazione
export async function fetchListPuntiVendita() {
  const url = `${baseUrl}estrazioni-pv-list`;
  const res = await axios.get(url);
  return res.data.data || [];
}

//Mi prendo tutti i comuni che hanno punti vendita con delle offerte
export async function fetchListPuntiVenditaOfferte() {
  const url = `${baseUrl}offerte-pv-comuni`;
  const res = await axios.get(url);
  return res.data.data || [];
}

//Restituisce tutti i comuni con i punti vendita
export async function fetchListComuni() {
  const url = `${baseUrl}pv-list-comuni`;
  const res = await axios.get(url);
  return res.data.data || [];
}

